<script>
	import CartListBaseVue from "../Carts/CartListBase.vue";
	export default {
		extends: CartListBaseVue,
	};
</script>